import React, { useContext } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useSnackbar } from "notistack";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailIcon from '@mui/icons-material/MailOutlineRounded';
import {AuthContext} from "../../contexts/AuthContext";
import theme from "../../theme";
import { getGroupEmail } from "../../helpers/authUser";

const useStyles = makeStyles((theme) => ({
    subText: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    link: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
}));

const ForwardDeals: React.FC<{}> = () => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const { userGroup } = useContext(AuthContext);

    return (<>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end" mr={2}>
            <EmailIcon sx={{ width: 28, height: 28, color: theme.colors.neutral['500'] }} />
            <Typography className={classes.subText}>
                {'Forward your deals to: '}
                <Typography component="span" className={classes.link}
                    onClick={() => window.open(`mailto: ${getGroupEmail(userGroup)}`, '_self', 'noopener, noreferrer')}
                    display="inline">
                    {getGroupEmail(userGroup)}
                </Typography>
                <CopyToClipboard text={`${getGroupEmail(userGroup)}`}
                    options={{ format: "text/plain" }}
                    onCopy={() => {
                        enqueueSnackbar(`Successfully copied to clipboard.`,
                            { anchorOrigin: { vertical: "bottom", horizontal: "right" }, });
                    }}>
                    <IconButton size="small" sx={{ color: theme.colors.cyan['500'] }}>
                        <ContentCopyIcon sx={{ width: 24, height: 24, }} />
                    </IconButton>
                </CopyToClipboard>
            </Typography>
        </Stack>
    </>);
}

export default ForwardDeals;
